import { useNavigate } from 'react-router-dom'
import { useProgressMapData } from '../hooks/map/useProgressMapData'
import { useThemeColors } from '../hooks/theme/useThemeColors'
import AppIcon from '../ui/icons/AppIcon'
import ProgressMap from '../ui/map/ProgressMap'
import styles from '../ui/map/MapScreen.module.css'

const MAP_LINE_VARS = ['--green', '--muted-2'] as const

export default function MapScreen() {
  const navigate = useNavigate()
  const mapState = useProgressMapData()
  const [completedColor, remainingColor] = useThemeColors(MAP_LINE_VARS)

  return (
    <div className={styles.shell}>
      <header className={styles.header}>
        <button type="button" className={styles.back} onClick={() => navigate(-1)} title="Back">
          <AppIcon icon="mdi:chevron-left" size={18} />
        </button>
        <h1 className={styles.title}>Route map</h1>
      </header>
      <div className={styles.mapFrame}>
        {mapState.status === 'loading' ? (
          <div className={styles.loading}>
            {mapState.error ? 'Could not load map.' : 'Loading map…'}
          </div>
        ) : (
          <ProgressMap
            interactive
            completedColor={completedColor}
            remainingColor={remainingColor}
            data={mapState.data}
          />
        )}
      </div>
    </div>
  )
}
